import { Pipe, PipeTransform } from '@angular/core';
import { UserdataService } from '../service/userdata.service';

@Pipe({
  name: 'getUsernameById',
  standalone: false
})
export class GetUsernameByIdPipe implements PipeTransform {
  constructor(
    private userData: UserdataService
  ) { }

  async transform(userId: string): Promise<string> {
    if (!userId) {
      return 'Unknown';
    }
    return await new Promise((resolve) => {
      this.userData.data.subscribe(async (data) => {

        if (data && userId == data.id) {
          resolve('You');
          return
        }
        let user: any = await this.userData.getUserByIdShort(userId);
        if (!user) {
          resolve('User not found');
          return
        }
        if (user.prename && user.lastname && user.lastname !== '' && user.prename !== '') {
          resolve(user.prename + ' ' + user.lastname);
        } else {
          resolve(user.email);
        }
      });
    });
  }

}
